import { BodyDecoder } from '@iotize/tap/client/api';
import { BodyEncoder } from '@iotize/tap/client/api';
import { ConverterError } from '../error';

export class Ipv4StringConverter
  implements BodyDecoder<string>, BodyEncoder<string>
{
  protected static _instance?: Ipv4StringConverter = undefined;

  public decode(body: Uint8Array): string {
    if (body == null || body.length != 4) {
      throw ConverterError.unexpectedBufferSize(4, body);
    }
    var result = '';
    var values = Array.from(body);
    for (var part of values) {
      result += part.toString() + '.';
    }
    return result.substr(0, result.length - 1);
  }

  public encode(ip: string): Uint8Array {
    var parts = ip.split('.');
    if (parts.length != 4) {
      throw new Error('Invalid ip format. Should be x.x.x.x');
    }
    var result = new Uint8Array(4);
    parts.map((value: string, index: number) => {
      result[index] = parseInt(value) & 0xff;
    });
    return result;
  }

  public static instance() {
    if (!Ipv4StringConverter._instance) {
      Ipv4StringConverter._instance = new Ipv4StringConverter();
    }
    return Ipv4StringConverter._instance;
  }
}
